import React, { useState, Fragment, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Location, gAPI_Location_By_Id, putAPI_Update_Location, putAPI_Delete_Location } from '../../../../../../constants/APIs';

export function AddNewService({
    id,
    visible,
    toggleModal,
    formLabel,
    propertyId
}) {
    const [deleteVisible, setDeleteVisible] = useState(false);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const [locationData, setLocationData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        name: '',
        address: '',
        city: '',
        openingHours: '',
        websiteLink: '',
        email: '',
        phone: '',
        status: 'Active',
        creator: 'dashboard'
    });

    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Location_By_Id}/${id}`,
            })
                .then(res => {
                    setLocationData(res.data)
                })
                .catch(err => console.log('err', err));
        }
    }, [id]);

    const handleChange = e => {
        setLocationData({
            ...locationData,
            [e.target.name]: e.target.value,
        });
    };

    const handleDelete = () => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Delete_Location}/${id}`,
            data: {
                deleter: 'dashboard'
            },
        })
            .then(res => {
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            })
            .catch(err => {
                console.log(err);
            });
    };

    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                      </span>
                      This location will be deleted!
                    </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                      </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                      </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleSubmit = () => {
        if (id !== undefined) {
            const formmatedData = { ...locationData, Updater: 'admin' };
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Location}/${id}`,
                data: formmatedData,
            })
                .then(res => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                }
                )
                .catch(err => {
                    console.log('err', err);
                });
        }
        else {
            const formmatedData = { ...locationData };
            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_Location}`,
                data: formmatedData,
            })
                .then(res => {
                    console.log(res.data);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleModal} wrapClassName="modal-right"
                backdrop="static">
                <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
                {locationData != undefined && (
                    <ModalBody>
                        {/* <pre>{JSON.stringify(serviceData, null, 2)}</pre> */}
                        <Label className="mt-3">
                            Name
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.name}
                            name="name"
                        />
                        <Label className="mt-3">
                            Address
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChange}
                            value={locationData.address}
                            name="address"
                        />
                        <Label className="mt-3">
                            Status
                    </Label>
                        <Input
                            type="select"
                            name="status"
                            value={locationData.status}
                            onChange={handleChange}
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </Input>
                        <Label className="mt-3">
                            City
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.city}
                            name="city"
                        />
                        <Label className="mt-3">
                            Opening Hours
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.openingHours}
                            name="openingHours"
                        />
                        <Label className="mt-3">
                            Website
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.websiteLink}
                            name="websiteLink"
                        />
                        <Label className="mt-3">
                            Email
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.email}
                            name="email"
                        />
                        <Label className="mt-3">
                            Phone
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.phone}
                            name="phone"
                        />

                    </ModalBody>)}
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Save
          </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
          </Button>
                    {id && (<Button color="danger" onClick={toggle}>
                        Delete
                    </Button>)}

                </ModalFooter>
            </Modal>
            {generateDeleteButton()}
        </Fragment >
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewService));